import { render, staticRenderFns } from "./DeliveryNotes.vue?vue&type=template&id=556d19a0&"
import script from "./DeliveryNotes.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotes.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports